<template>
  <div class="header">
    <div class="header-left">
      <!-- logo -->
      <div class="logo">
        <img src="../assets/logo_top.png" alt="logo">
      </div>

      <!-- 面包屑 -->
      <div class="breadcrumb f-s-18" v-if="route.length > 1">
        <span v-for="(n, i) of route" :key="i">
          <template v-if="route.length > 0 && i < route.length - 1">
            <router-link :to="n.path">{{ n.name }}</router-link>&nbsp;>&nbsp;
          </template>
          <template v-else>{{ n.name}}</template>
        </span>
      </div>
    </div>

    <!-- 用户管理 -->
    <accountManagement
      v-if="accountManagementVisible"
      class="absolute" @close="closeAccountManager" />
      <!--  -->
    <myDownload
      v-if="downloadVisible"
      class="absolute" @close="closeDownload" />
    <!-- 用户信息 -->
    <UserInfo class="absolute" @success="getUserData" :visible="userInfoVisible" :data="user" @close="handleUserClick" />
    <!-- 修改密码 -->
    <ChangePassword class="absolute" v-if="changePwdVisible" :visible="changePwdVisible" @close="handlePwdClick" />
    <!-- <projectList class="absolute" v-if="projectLstVisible" :listVisible="projectLstVisible" @close="handleProjectClick" :DialogTitle='projectListTitle'></projectList> -->
    <!-- 导入项目 -->
    <projectLead :hasProject='true'
      v-if="leadDialog" :DialogVisible='leadDialog' @close='closeProjecLead'
      @callback="reload" @goRouter='goRouter'
      :projectId='projectId'></projectLead>
    <el-dialog
      :close-on-click-modal="false"
      class="modal"
      :title="$t('prompt')"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <div class="dialog-title" slot="title">
        <i class="iconfont el-icon-info"></i>
        {{ $t('prompt') }}
      </div>
      <span>{{ $t('signOutPrompt') }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button class="gray-btn" @click="dialogVisible = false">{{ $t('cancel') }}</el-button>
        <el-button class="blue-btn" @click="quit">{{ $t('sure') }}</el-button>
      </span>
    </el-dialog>
    <!-- 个人信息 -->
    <div class="user">
      <el-select v-model="language" @change="changeLanguages" style="width: 120px; margin-right: 8px">
        <el-option
          v-for="item in languageArr"
          :key="item.value"
          :label="item.name"
          :value="item.value">
        </el-option>
      </el-select>
      <el-tooltip :content="$t('help')" placement="bottom">
        <i class="iconfont icon-wenhao" style="font-size: 24px;margin-left: 14px" @click="linkHelp"></i>
      </el-tooltip>
      <!-- 导出 -->
      <span class="project-name">
        {{ projectName }}
        <el-tooltip v-if="projectName" :content="$t('importPanel')" placement="bottom">
          <i class="iconfont icon-daochu1 pointer" style="margin: 0 10px 0 10px; font-size: 23px" @click="importPanel"></i>
        </el-tooltip>
        <el-tooltip v-if="projectName" :content="$t('exportPanel')" placement="bottom">
          <i class="iconfont icon-daoru1 pointer" style="margin: 0 28px 0 10px; font-size: 23px" @click="exportPanel"></i>
        </el-tooltip>
      </span>
      <el-dropdown trigger="click">
        <span class="el-dropdown-link">
          <!-- @click="handleUserClick(true)" -->
          <span class="user-info pointer">
            <i class="iconfont iconyonghu account"></i>
            <span class="user-name">{{ userName }}</span>
          </span>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown" class="userinfo-list">
          <el-dropdown-item @click.native="handleUserClick(true)"><i class="iconfont icon-yonghu"></i>{{ $t('userInfo') }}</el-dropdown-item>
          <el-dropdown-item @click.native="handlePwdClick(true)"><i class="iconfont icon-mima"></i>{{ $t('changePassword') }}</el-dropdown-item>
          <el-dropdown-item @click.native="handleProjectClick(true)"><i class="iconfont icon-xiangmutubiao"></i>{{ $t('myProjects') }}</el-dropdown-item>
          <el-dropdown-item @click.native="handleDownloadClick(true)"><i class="iconfont icon-xiazai"></i>{{ $t('myDownload') }}</el-dropdown-item>
          <el-dropdown-item @click.native="handleCommand" v-if="showAccountManage"><i class="iconfont iconyonghuguanli"></i>{{ $t('accountManagement') }}</el-dropdown-item>
          <el-dropdown-item @click.native="handleQuit"><i class="iconfont icontuichu quit"></i>{{ $t('signOut') }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>

</template>

<script>
import accountManagement from '../views/user/accountManagement'
import UserInfo from '../views/user/userInfo'
import ChangePassword from '../views/user/changePassword'
import { mapActions } from 'vuex'
import Cookies from 'js-cookie'
import config from '../common/config'
import { getUserInfo } from '../api/user'
import myDownload from '../views/user/myDownload'
import { projectDown } from '../api/config'
import { EventBus } from '../store/eventBus'
import projectLead from '../views/configFile/projectLeading'

export default {
  name: 'topbar',
  components: {
    accountManagement,
    UserInfo,
    ChangePassword,
    // projectList,
    myDownload,
    projectLead
  },
  props: ['route', 'projectName', 'projectId'],
  data () {
    return {
      show: false,
      accountManagementVisible: false,
      userInfoVisible: false,
      changePwdVisible: false,
      dialogVisible: false,
      userName: '',
      user: {},
      downloadVisible: false,
      showAccountManage: false,
      leadDialog: false,
      language: Cookies.get(config.language) || 'english',
      languageArr: [{
        name: 'English',
        value: 'english'
      }, {
        name: 'Español',
        value: 'spanish'
      }, {
        name: 'Português',
        value: 'portuguese'
      }]
      // projectLstVisible: false,
      // projectListTitle:this.$t('myProjectDialog')
    }
  },
  mounted () {
    this.userName = Cookies.get(config.accoutName)
    this.showAccountManage = +Cookies.get(config.role) === 3
    this.getUserData()
  },
  methods: {
    ...mapActions([
      'changeLanguage',
      'changeProjectVisible'
    ]),
    reverse () {
      this.show = !this.show
    },
    handleCommand (command) {
      this.accountManagementVisible = true
    },
    closeAccountManager (val) {
      this.accountManagementVisible = val
    },
    handleUserClick (visible) {
      this.userInfoVisible = visible
    },
    handlePwdClick (visible) {
      this.checkoutSave(() => {
        this.changePwdVisible = visible
      })
    },
    handleProjectClick (visible) {
      // this.projectLstVisible = visible
      // this.$router.push('/project')
      this.checkoutSave(() => {
        this.changeProjectVisible(true)
      })
    },
    handleQuit () {
      this.checkoutSave(() => {
        this.dialogVisible = true
      })
    },
    quit () {
      config.clearUserData()
      this.dialogVisible = false
      this.$router.replace({ path: '/login' })
      // setTimeout(() => {
      //   window.location.reload()
      // }, 20)
    },
    changeLanguages () {
      Cookies.set(config.language, this.language)
      this.$i18n.locale = this.language
      window.location.reload()
    },
    getUserData () {
      getUserInfo().then(res => {
        this.user = res.data
        // Cookies.set(config.userInfo, JSON.stringify(res.data), { expires: 0.25})
      })
    },
    handleDownloadClick (visible) {
      this.downloadVisible = visible
    },
    closeDownload (val) {
      this.downloadVisible = val
    },
    exportPanel () {
      const params = {
        panelNo: this.$route.query.panelNo,
        projectId: this.$route.query.projectId,
        userId: Cookies.get(config.userId),
        lan: this.language
      }
      projectDown(params).then(res => {
        this.$message.success(this.$t('deviceExportSuccess'))
      })
    },
    importPanel () {
      this.leadDialog = true
    },
    // 检查子模块是否保存
    checkoutSave (cb) {
      // 判断是否注册了事件，没有则直接调用cb()
      if (EventBus._events.checkSave) {
        EventBus.$emit('checkSave', cb)
      } else {
        cb()
      }
    },
    closeProjecLead(){
      this.leadDialog = false;
    },
    reload () {
      window.location.reload()
    },
    linkHelp () {
      window.open('https://www.jadebird.eu.com/configtool')
    },
    goRouter (data){
        let item = data.panels[0]
        this.$router.push({path:this.$route.path,query:{
            panelId:item.id,
            panelNo:item.panelNo,
            projectId:item.projectId,
            projectName: data.site
        }})
    },
  }
}
</script>

<style lang="less" scoped>
.header {
  height: 78px;
  .flex();
  .align-center();
  .between();
  .header-left {
    .flex();
    .between();
    .align-center();
    margin-left: 30px;
  }
  .logo{
    width: 150px;
    // height: 78px;
    .flex();
    .align-center();
    overflow: hidden;
    img {
      width: 150px;
      background-position: center;
    }
  }
  .breadcrumb {
    margin-left: 50px;
    color: @color-primary;
    a {
      color: @color-primary;
    }
  }
  .user {
    margin-right: 30px;
    // color: @color-primary;
    i {
      color: #83909b;
    }
    > i {
      .f-s-20();
      color: #83909b;
      margin-right: 20px;
      cursor: pointer;
    }
    .user-info {
      margin-right: 10px;
      display: inline-block;
      .account {
        .f-s-24();
        margin-right: 14px;
      }
      .user-name {
        color: #83909b;
        position: relative;
        top: -2px;
      }
    }
    i.quit {
      .f-s-16();
      margin-right: 0;
    }
  }
  .absolute {
    position: absolute;
  }
  .language {
    i {
      position: relative;
      font-size: 22px;
      top: 1px;
      left: -9px;
    }
  }
}
.userinfo-list {
  i {
    color: #83909b;
    margin-right: 10px;
    font-size: 18px;
  }
  .el-dropdown-menu__item {
    color: #83909b;
  }
}
.project-name {
  color: #83909b;
  font-size: 18px;
}
</style>

<style lang="less">
// .user {
//   .el-dropdown-menu__item {
//     font-size: 14px;
//     i {
//       color: #FF9800;
//       margin-right: 10px;
//     }
//   }
// }
</style>
